import React from 'react';

const Dashboard = () => {
    return (
        <div>Hi</div>
    )
}

export default Dashboard